import {
  has,
  isArray,
  isBoolean,
  isNil,
  isNumber,
  isObject,
  isString,
  toLower,
  toString,
} from "lodash";
import { DataTypeEnum } from "@/src/shared/models/contextInstance";
import { ContextVariableValueType } from "../schemas";

export const parseBoolean = (value: unknown) => {
  if (isString(value)) {
    const lowerValue = toLower(value);
    return lowerValue === "true";
  }
  return Boolean(value);
};

export const parceContextVariablesByDataType = (
  value: ContextVariableValueType,
  dataType: DataTypeEnum,
) => {
  if (!value) return value;
  switch (dataType) {
    case DataTypeEnum.NUMBER:
      return Number(value);
    case DataTypeEnum.STRING:
      return isObject(value) && has(value, 'value') ? value?.value : value;
    case DataTypeEnum.OPTION:
      return isObject(value) ? value : { label: value, value: value };
    default:
      return value;
  }
};

export const parseContextVariableValue = (
  _value: ContextVariableValueType,
  options?: { dataType?: DataTypeEnum; key?: string; isArray?: boolean },
): string | null => {
  const { dataType, key, isArray:_isArray } = options || {};
  const value =
    dataType && (!_isArray && !isArray(_value))
      ? parceContextVariablesByDataType(_value, dataType)
      : _value;

  if (isString(value)) {
    if (key === "codeToVerify") {
      return `W${value}`;
    }
    return value;
  } else if (isNumber(value) || isBoolean(value)) {
    return toString(value);
  } else if (isNil(value)) {
    return null;
  } else if (isArray(value) || isObject(value)) {
    return JSON.stringify(value);
  }
  return null;
};

export const parseSelectFieldValue = (
  value: unknown,
  mode: "multiple" | "default" = "default",
) => {
  if (isArray(value) && mode === "multiple") {
    return value;
  } else if (isObject(value) && has(value, "value")) {
    return value.value;
  }

  return value;
};

export const isJSON = (value: unknown): value is string => {
  if (!isString(value)) {
    return false;
  }
  const jsonRegex =
    /^(?:\s*(true|false|null|\[.*\]|\{.*\}|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?|"[^"\\]*(?:\\.[^"\\]*)*")\s*)$/;

  return jsonRegex.test(value.trim());
};
